const useBPATaxDocuments = (stateId, formData, beforeUploadDocuments) => {

    const { isLoading: bpaDocsLoading, data: bpaDocs } = Digit.Hooks.obps.useMDMS(stateId, "BPA", ["DocTypeMapping"]);
    const { isLoading: commonDocsLoading, data: commonDocs } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["DocumentType"]);
    const documents = beforeUploadDocuments;
    const { data, isLoading, error } = Digit.Hooks.useDocumentSearch( documents, { enabled: beforeUploadDocuments?.length > 0 ? true : false});
    if (data?.pdfFiles?.length > 0) {
        beforeUploadDocuments = data?.pdfFiles
    }


    let filtredBpaDocs = [];
    console.log(bpaDocs, "mainDOCS");
        if (bpaDocs?.BPA?.DocTypeMapping) {
          if (["FORM_11", "FORM_26"].includes(formData?.applicationType)) {
            filtredBpaDocs = bpaDocs?.BPA?.DocTypeMapping?.filter(data => (
              data.ServiceType == formData?.applicationType && data.applicationType == formData?.applicationType
            ))
          } else {
            filtredBpaDocs = bpaDocs?.BPA?.DocTypeMapping?.filter(data => 
            data.WFState == "INITIATE" && data.RiskType == formData?.data?.riskType && data.ServiceType == formData?.data?.serviceType && data.applicationType == formData?.data?.edcrDetails?.appliactionType
            //filtredBpaDocs = bpaDocs?.BPA?.DocTypeMapping?.filter(data => (data.applicationType == "BUILDING_PLAN_SCRUTINY"))
        )}
          }
        let documentsList = [];
        filtredBpaDocs?.[0]?.docTypes?.forEach(doc => {
            let code = doc.code; doc.dropdownData = []; doc.uploadedDocuments = [];
            commonDocs?.["common-masters"]?.DocumentType?.forEach(value => {
                let values = value.code.slice(0, code.length);
                if (code === values) {
                    doc.hasDropdown = true;
                    value.i18nKey = value.code;
                    doc.dropdownData.push(value);
                }
            });
            
            doc.uploadedDocuments[0] = {};
            doc.uploadedDocuments[0].values = [];
            beforeUploadDocuments.map(upDocs => {
                if (code === `${upDocs?.documentType?.split('.')[0]}.${upDocs?.documentType?.split('.')[1]}`) {
                    doc.uploadedDocuments[0].values.push(upDocs)
                }
            })
            documentsList.push(doc);
        });


    return { data: documentsList , isLoading: bpaDocsLoading || commonDocsLoading }

}

export default useBPATaxDocuments